import React from 'react'
import {
  Container,
  Header,
} from 'semantic-ui-react'

const Ids = () => (
  <Container text style={{ marginTop: '7em' }}>
    <Header as='h1'>Ids for Areas, Units, Topics, and Outcomes</Header>
    <p>
      The <a href="https://www.acm.org/binaries/content/assets/education/cs2013_web_final.pdf">CS2013 PDF document</a> uses
      a set of unique abbreviations for the knowledge areas (AL, AR, ...).
      It also numbers each learning outcome.
      However, it does not otherwise use any short and unique identifiers.
      That is, the knowledge units and the (sometimes hierarchical) topics
      have no unambigous and well-known identifiers.
    </p>
    <p>
      To allow the unambiguous identification of any item of the curriculum
      (area, unit, topic, or outcome),
      we introduced IDs for each item.
      The JSON file uses the key 'id' for a local id (unique amongst siblings)
      and the key 'fqid' for a fully-qualified id.
    </p>
    <p>
      <strong>Knowledge Areas</strong>.
      The IDs for knowledge areas are identical to the abbreviations used in the PDF
      (two or three letter abbreviations).
    </p>
    <p>
      <strong>Knowledge Units</strong>.
      The knowledge units are numbered in the order of appearance within their area.
      Their 'fqid' is the concatenation of the knowledge area 'id' and their local 'id'
      (e.g., AR1, AR2, SDF1).
    </p>
    <p>
      <strong>Topics</strong>.
      The topics are numbered in order of their appearance within their parent.
      Their 'fqid' is the concatenation of the parent's 'fqid', a dot, and their local 'id'
      (e.g., AL1.1, AL1.2, CN2.5.1, PD3.4.3.1)
    </p>
    <p>
      <strong>Learning Outcomes</strong>.
      The IDs of the learning outcomes correspond to the numbers in the PDF,
      which is equivalent to the order of their appearance.
      To distinguish learning outcomes from topics,
      the 'fqid' of learning outcomes are separated from the 'fqid' of their knowledge unit with an 'o'
      (e.g., AL1o1, AL1o2, AL2o1).
    </p>
    <p>
      While storing the 'id' and 'fqid' inside the item in JSON is not strictly necessary
      (the IDs could be computed based on the order in which the items appear in the JSON arrays),
      having the IDs available makes some tasks easier for users of the JSON file,
      and the ready availability increases the chance that everyone will use the same numbering system.
    </p>
  </Container>
)

export default Ids